export default __webpack_public_path__ + "static/media/chilli.2c12e08b.png";